module.exports = __webpack_public_path__ + "img/newchris-39.9c50065d.jpg";